module.exports = __webpack_public_path__ + "img/bn.2d173866.svg";